window.addEventListener('DOMContentLoaded', () => {
    customTwinVideoPlayerSettingsWrapper();

    function customTwinVideoPlayerSettingsWrapper(){
        // general
        let windowScreenWidth = window.screen.width;
        let pucVideoPlayer = document.getElementsByClassName("puc--video-player");

        if(!pucVideoPlayer){
            return;
        }

        let pucMobileVideoPlayer = document.getElementsByClassName("puc--mobile-video-player");

        if(!pucMobileVideoPlayer){
            return;
        }

        let pucVidSoundControls = document.getElementsByClassName("puc-vid-sound-controls");

        // specifics
        const pucCustomVideoPlayer = document.querySelector(".puc-custom-video-player");
        const MobilePucCustomVideoPlayer = document.querySelector(".mobile-puc-custom-video-player");

        const pucCustomVideoPlayerTwo = document.querySelector(".puc-custom-video-player-two");
        const MobilePucCustomVideoPlayerTwo = document.querySelector(".mobile-puc-custom-video-player-two");
        
        let pucCustomVideoSound = document.getElementsByClassName("puc-custom-video-sound");
        let pucCustomVideoSoundTwo = document.getElementsByClassName("puc-custom-video-sound-two");

        desktopOnLoadCheck();

        function desktopOnLoadCheck(){
            // (DESKTOP) on load actions
            for (let loop=0; loop<pucVideoPlayer.length; loop++){
                if (windowScreenWidth >= 951 && pucVideoPlayer[loop]){
                    // on load play video
                    pucVideoPlayer[loop].autoplay;
                    pucVideoPlayer[loop].play();
                    pucVideoPlayer[loop].muted = true;
        
                    // when video finishes, loop play
                    pucVideoPlayer[loop].addEventListener('ended',videoLoopPlay,false);
        
                    function videoLoopPlay() {
                        pucVideoPlayer[loop].play();
                    }
        
                    onLoadHideSound();
                }
            }
        }

        mobileOnLoadCheck();

        function mobileOnLoadCheck(){
            // (MOBILE) on load actions
            for (let loopMobile=0; loopMobile<pucMobileVideoPlayer.length; loopMobile++){
                if (windowScreenWidth <= 950 && pucMobileVideoPlayer[loopMobile]){
                    // on load play video
                    pucMobileVideoPlayer[loopMobile].autoplay;
                    pucMobileVideoPlayer[loopMobile].play();
                    pucMobileVideoPlayer[loopMobile].muted = true;
        
                    // when video finishes, loop play
                    pucMobileVideoPlayer[loopMobile].addEventListener('ended',videoLoopPlay,false);
        
                    function videoLoopPlay() {
                        pucMobileVideoPlayer[loopMobile].play();
                    }

                    onLoadHideSound();
                }
            }
        }

        function onLoadHideSound(){
            for(let i=0; i<pucVidSoundControls.length; i++){
                // on load hide icon
                let soundIcon = pucVidSoundControls[i].getAttribute("puc-custom-video-control");
                let soundIconTwo = pucVidSoundControls[i].getAttribute("puc-custom-video-control-two")

                if(soundIcon == "sound-on" || soundIconTwo == "sound-on"){
                    pucVidSoundControls[i].style.display = "block";
                }
                if(soundIcon == "sound-off" || soundIconTwo == "sound-off"){
                    pucVidSoundControls[i].style.display = "none";
                }
            }
        }

        // on click mute/activate sound
        document.addEventListener('click',function(clicked){

            //---------- block one
            if(clicked.target.parentNode.hasAttribute("puc-custom-video-control")){

                // clicked icon attribute
                let clickedSoundIconAttribute = clicked.target.parentNode.getAttribute("puc-custom-video-control");

                for(let j=0; j<pucCustomVideoSound.length; j++){

                    // (DESKTOP) on click mute/activate sound
                    if (windowScreenWidth >= 951 && pucCustomVideoPlayer){
                        if(clickedSoundIconAttribute == "sound-on"){
                            pucCustomVideoPlayer.muted = false;
                            pucCustomVideoSound[j].style.display = "none";

                            if(pucCustomVideoSound[j].getAttribute("puc-custom-video-control") == "sound-off"){
                                pucCustomVideoSound[j].style.display = "block";
                            }
                        }
                        if(clickedSoundIconAttribute == "sound-off"){
                            pucCustomVideoPlayer.muted = true;
                            pucCustomVideoSound[j].style.display = "none";

                            if(pucCustomVideoSound[j].getAttribute("puc-custom-video-control") == "sound-on"){
                                pucCustomVideoSound[j].style.display = "block";
                            }
                        }
                    }

                    // (MOBILE) on click mute/activate sound
                    if (windowScreenWidth <= 950 && MobilePucCustomVideoPlayer){
                        if(clickedSoundIconAttribute == "sound-on"){
                            MobilePucCustomVideoPlayer.muted = false;
                            pucCustomVideoSound[j].style.display = "none";

                            if(pucCustomVideoSound[j].getAttribute("puc-custom-video-control") == "sound-off"){
                                pucCustomVideoSound[j].style.display = "block";
                            }
                        }
                        if(clickedSoundIconAttribute == "sound-off"){
                            MobilePucCustomVideoPlayer.muted = true;
                            pucCustomVideoSound[j].style.display = "none";

                            if(pucCustomVideoSound[j].getAttribute("puc-custom-video-control") == "sound-on"){
                                pucCustomVideoSound[j].style.display = "block";
                            }
                        }
                    }

                }
            }

            // ---------- block two
            if(clicked.target.parentNode.hasAttribute("puc-custom-video-control-two")){

                // clicked icon attribute
                let clickedSoundIconAttribute = clicked.target.parentNode.getAttribute("puc-custom-video-control-two");

                for(let l=0; l<pucCustomVideoSoundTwo.length; l++){

                    // (DESKTOP) on click mute/activate sound
                    if (windowScreenWidth >= 951 && pucCustomVideoPlayerTwo){
                        if(clickedSoundIconAttribute == "sound-on"){
                            pucCustomVideoPlayerTwo.muted = false;
                            pucCustomVideoSoundTwo[l].style.display = "none";

                            if(pucCustomVideoSoundTwo[l].getAttribute("puc-custom-video-control-two") == "sound-off"){
                                pucCustomVideoSoundTwo[l].style.display = "block";
                            }
                        }
                        if(clickedSoundIconAttribute == "sound-off"){
                            pucCustomVideoPlayerTwo.muted = true;
                            pucCustomVideoSoundTwo[l].style.display = "none";

                            if(pucCustomVideoSoundTwo[l].getAttribute("puc-custom-video-control-two") == "sound-on"){
                                pucCustomVideoSoundTwo[l].style.display = "block";
                            }
                        }
                    }

                    // (MOBILE) on click mute/activate sound
                    if (windowScreenWidth <= 950 && MobilePucCustomVideoPlayerTwo){
                        if(clickedSoundIconAttribute == "sound-on"){
                            MobilePucCustomVideoPlayerTwo.muted = false;
                            pucCustomVideoSoundTwo[l].style.display = "none";

                            if(pucCustomVideoSoundTwo[l].getAttribute("puc-custom-video-control-two") == "sound-off"){
                                pucCustomVideoSoundTwo[l].style.display = "block";
                            }
                        }
                        if(clickedSoundIconAttribute == "sound-off"){
                            MobilePucCustomVideoPlayerTwo.muted = true;
                            pucCustomVideoSoundTwo[l].style.display = "none";

                            if(pucCustomVideoSoundTwo[l].getAttribute("puc-custom-video-control-two") == "sound-on"){
                                pucCustomVideoSoundTwo[l].style.display = "block";
                            }
                        }
                    }

                }
            }
            
        });

    }
});